// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\DispatchEventDetailsBillingViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';

// DispatchEventDetailsBillingData is the class that DispatchEventDetailsBilling serializes to/from
export interface DispatchEventDetailsBillingData {
    Id : number;
	
    DispatchEvent : DispatchEventData | null;
	
    LastExportDate : /* ISO8601 */ string | null;
}

// DispatchEventDetailsBillingOptions is the class which may be passed to the DispatchEventDetailsBilling constructor to define optional initial data values
export interface DispatchEventDetailsBillingOptions {
    Id : number;
	
    DispatchEvent? : DispatchEventOptions | null;
	
    LastExportDate? : /* ISO8601 */ string | null;
}

export class DispatchEventDetailsBilling {
    public Id : DataSignal<number>;
	
    public DispatchEvent : DataSignal<DispatchEvent | null>;
	
    public LastExportDate : DataSignal<TZDate | null>;

    constructor();
    constructor(data : DispatchEventDetailsBillingOptions);
    constructor(data: DispatchEventDetailsBillingOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.DispatchEvent = S.value<DispatchEvent | null>(null);
	    
        this.LastExportDate = jsonableObservable(S.value<TZDate | null>(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate(data.LastExportDate) : null, TZDate.nullableEq));
    }

    static key(obj : DispatchEventDetailsBilling) {
        return obj.Id();
    }
    
    static dataKey(obj : DispatchEventDetailsBillingOptions) {
        return obj.Id;
    }

    static update(obj : DispatchEventDetailsBilling, data : DispatchEventDetailsBillingOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.LastExportDate !== undefined) obj.LastExportDate(data.LastExportDate === null ? null : new TZDate(data.LastExportDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DispatchEventDetailsBilling.ts